module.exports = __webpack_public_path__ + "img/mario-min.e99228a1.png";